export default __webpack_public_path__ + "static/media/yellow-online_banking.3bd0bec0.svg";